<div class="station-selection-menu">
  <sc-padding fitHeight>
  <sc-flex vertical stretchContent fitHeight>
    <sc-flex>
      <sc-title><sc-dictionary-label dictionaryKey="Stationsauswahl"
          defaultValue="Stationsauswahl"></sc-dictionary-label></sc-title>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-icon iconClass="fa-close close-action" (click)="clickClose()"></sc-icon>
    </sc-flex>
    <sc-content-spacer vertical></sc-content-spacer>
    <sc-flex-fitting-content vertical>
      <sc-scroll-pane>
        <ng-container *ngFor="let group of stationGroups; let i = index;">
          <sc-content-spacer vertical *ngIf="i > 0"></sc-content-spacer>
          <div class="group-container">
            {{group.name}}
            <ng-container *ngFor="let set of group.stationSets">
              <sc-content-spacer vertical></sc-content-spacer>
              <div class="station-set-container">
                {{set.name}}
                <ng-container *ngFor="let station of set.stations; let k = index;">
                  <sc-content-spacer vertical></sc-content-spacer>
                  <div class="station" (click)="selectStation(set, station)">{{station.name}}</div>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </sc-scroll-pane>
    </sc-flex-fitting-content>
  </sc-flex>
</sc-padding>
</div>
